import React from 'react'
import Tracking from './tracking/Tracking'
import { NavLink, useParams } from "react-router-dom";

export default function Trackingdetails() {
  const { conNumber } = useParams();

  return (
    <div>
        <Tracking conNumber={conNumber}/>
    </div>
  )
}
